// extracted by mini-css-extract-plugin
export default {"iconContainer":"ContactIcons_iconContainer__AlT+s","icon":"ContactIcons_icon__1jW0T"};